import React from 'react';
import { Mail, Phone, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = ({ t, onShowImprint, onShowPrivacy }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">Chalhoub Trade</h3>
            <p className="footer-slogan">{t.footer.slogan}</p>
            <p className="footer-description">{t.footer.description}</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">{t.footer.quickLinks}</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('services')}>{t.nav.services}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-partner')}>{t.nav.whyUs}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')}>{t.nav.contact}</button>
              </li>
              <li>
                <button onClick={onShowImprint}>{t.nav.imprint}</button>
              </li>
              <li>
                <button onClick={onShowPrivacy}>{t.nav.privacy}</button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">{t.footer.contactInfo}</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <a className="ltr" href="mailto:sami.chalhoub@chalhoubtrade.de">sami.chalhoub@chalhoubtrade.de</a>
              </li>
              <li>
                <Phone size={16} />
                <a
                  className="ltr"
                  href="https://wa.me/+4915226573461"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +49 152 2657 3461
                </a>
              </li>
              <li>
                <Linkedin size={16} />
                <a
                  className="footer-linkedin-text ltr"
                  href="https://www.linkedin.com/company/chalhoubtrade/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedin.com/company/chalhoubtrade
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t.footer.copyright} {new Date().getFullYear()} Chalhoub Trade. {t.footer.allRights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;